export default "__VITE_ASSET__CEFau66X__"